import lodashGet from 'lodash/get'
import {isVNode} from "../../../../tools/utils";
export default {
  props: {
    scope: {
      type: Object,
      require: true
    }
  },
  render(h, context) {
    let {row, $index, column} = this.scope
    let value = lodashGet(row, column.property)
    if(value === undefined || value === null){
      value = ""
    }
    if(column.formatter){
      // 获取值
      const VNode = column.formatter(row, column, value, $index)
      return isVNode(this, VNode) ? VNode : h('span', VNode);
    }else {
      return h('span', value)
    }
  }
}
